<template>
  <div>
    <template v-if="editable">
      <v-select
        class="user-search"
        v-model="selectedValue"
        :options="options"
        :reduce="option => option.id"
        :get-option-label="option => option.display_name || option.name"
        :disabled="isProcessing || !officeId"
        @change="onChange"
      />
    </template>
    <template v-else>
      <div class="form-control-plaintext">
        {{ userName }}
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'

const props = defineProps({
  modelValue: [String, Number],
  officeId: [String, Number],
  users: {
    type: Array,
    default: () => []
  },
  clearAfterSelected: Boolean,
  editable: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const isProcessing = ref(false)

// Compute selected user based on modelValue and users array
const selectedUser = computed(() => {
  if (!props.modelValue || !props.users?.length) return null
  const user = props.users.find(user => user.id === Number(props.modelValue))
  return user
})

// Watch for changes
watch(() => props.modelValue, (newVal) => {
})

watch(() => props.editable, (newVal) => {
})

// Compute options for v-select
const options = computed(() => {
  return props.users || []
})

// Create computed property for selectedValue
const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
  }
})

// Handle change event
const onChange = (value) => {
  emit('change', value)
  if (value && props.clearAfterSelected) {
    selectedValue.value = null
  }
}

// Initialize values when component is mounted
onMounted(() => {
  if (props.modelValue) {
    selectedValue.value = props.modelValue
  }
})

// Thêm kiểm tra để đảm bảo không bị lỗi khi selectedUser là null
const userName = computed(() => {
  if (!selectedUser.value) return ''
  return selectedUser.value.display_name || ''
})
</script>

<style scoped>
.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
</style>
